module.exports = __webpack_public_path__ + "static/img/report.308f3830.png";